import { Col, Row } from "antd";
import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { DateHelper, StringHelper } from "../../../../../../../helper";
interface Props {
  data: any;
}

export const AccidentLeaveApplicationDetail = ({ data }: Props) => {
  return (
    <Row gutter={[32, 0]}>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Họ và tên" textRight={data?.eRequestName} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Mã nhân viên" textRight={data?.eEmployeeId} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Cơ quan/Đơn vị"
          textRight={
            StringHelper.verticalBarSplit<string[]>(data?.eDepartment)[1]
          }
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Phòng"
          textRight={StringHelper.verticalBarSplit<string[]>(data?.eUnit)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Đội"
          textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Thời gian xin nghỉ phép"
          textRight={DateHelper.formatRangeDateToString(data?.eVacationPeriod)}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Thời gian (dự kiến) quay trở lại làm việc"
          textRight={DateHelper.formatDateToString(data?.eExpectedReturnDate)}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lý do" textRight={data?.eReason} />
      </Col>
    </Row>
  );
};
